import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-034ff610"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "text-center"
}
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "form-field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Unit Type", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Start Date for Billing Cycle", -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "form-field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Promotions", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "None", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Plan", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/_createTextVNode("months")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" month")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "custom" }, "Custom", -1))
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "form-field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customAmount" }, "Monthly Price before Discount($)", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = { class: "form-field" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "discount" }, "Discount (%)", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "discount" }, "Billing cycle", -1))
const _hoisted_32 = ["value"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 2,
  class: "form-field"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Tenant Protection", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No Plan", -1))
const _hoisted_38 = ["value"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Auto Protect will be based off the agreement date if the agreement is signed after the move-in date. ", -1))
const _hoisted_40 = {
  key: 3,
  class: "form-field"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Insurance Plans", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No Plan", -1))
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "form-field" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Charge Deposit", -1))
const _hoisted_46 = { key: 4 }
const _hoisted_47 = { class: "form-field" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Deposit ($)", -1))
const _hoisted_49 = { class: "form-field" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Mark Deposit as previously paid", -1))
const _hoisted_51 = { class: "form-field" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Charge Setup Fee", -1))
const _hoisted_53 = { key: 5 }
const _hoisted_54 = { class: "form-field" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Setup Fee ($)", -1))
const _hoisted_56 = {
  key: 0,
  class: "form-field"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Setup fee tax rate (%) ", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No Tax", -1))
const _hoisted_59 = ["value"]
const _hoisted_60 = { class: "form-field" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Prorating Options", -1))
const _hoisted_62 = ["value"]
const _hoisted_63 = { class: "form-field" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Move-in Date", -1))
const _hoisted_65 = {
  key: 6,
  class: "form-field"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Tax rate (%)", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No Tax", -1))
const _hoisted_68 = ["value"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Rent", -1))
const _hoisted_70 = { key: 0 }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Rent Promotion Amount", -1))
const _hoisted_72 = { key: 1 }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Prorated Rent", -1))
const _hoisted_74 = { key: 2 }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Prorated Rent", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Tax", -1))
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" Tenant Protection Fee ")
const _hoisted_81 = /*#__PURE__*/_createTextVNode("Insurance Fee")
const _hoisted_82 = { key: 1 }
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" Prorated Tenant Protection Fee ")
const _hoisted_84 = /*#__PURE__*/_createTextVNode("Prorated Insurance Fee")
const _hoisted_85 = { key: 2 }
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" Tenant Protection Fee Tax ")
const _hoisted_87 = /*#__PURE__*/_createTextVNode("Insurance Fee Tax")
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { key: 4 }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Deposit", -1))
const _hoisted_92 = { key: 5 }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Setup Fee", -1))
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { key: 6 }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Setup Fee Tax", -1))
const _hoisted_98 = { key: 0 }
const _hoisted_99 = ["onClick"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Total Due", -1))
const _hoisted_101 = { key: 8 }
const _hoisted_102 = { key: 9 }
const _hoisted_103 = { key: 0 }
const _hoisted_104 = { class: "form-field" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = {
  key: 0,
  class: "col"
}
const _hoisted_107 = /*#__PURE__*/_createTextVNode(" Generating Quote ")
const _hoisted_108 = {
  key: 1,
  class: "col"
}
const _hoisted_109 = {
  key: 2,
  id: "quote-options"
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Disclaimer: Prices subject to change based on unit availability or other changes. ", -1))
const _hoisted_111 = { class: "row horizontal-center" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Print", -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Create", -1))
const _hoisted_114 = /*#__PURE__*/_createTextVNode("New Customer")
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Fulfill this Quote", -1))

import { ref, watch, onMounted } from "vue";
import moment from "moment";
import BaseSpinner from "@/components/BaseSpinner.vue";

import api from "@virgodev/bazaar/functions/api";
import { UnitTypeInterface, TenantProtectionPlanInterface } from "@/types/unit";
import {
  TaxRateInterface,
  FeesProductInterface,
  // eslint-disable-next-line
  PromotionInterface,
} from "@/types/customers";
import FeeProduct from "./FeeProduct.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const quote = ref();
const status = ref("loading");
const amountRented = ref();
const unitTypes = ref(Array<UnitTypeInterface>());
const selectedUnitType = ref();
const selectedUnit = ref();
const selectedTaxRate = ref();
const selectedFeeTaxRate = ref();
const errors = ref("");
const customPrice = ref(false);
const formSubmitting = ref(false);
const customAmount = ref(null);
const tenantProtectionPlans = ref(Array<TenantProtectionPlanInterface>());

const promotions = ref();


const taxRates = ref();
const billingOptions = ref([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
const proratingOptions = ref([
  { text: "No Prorating", value: "none" },
  {
    text: "Bill for first full month, Prorate second month billed now",
    value: "full_now",
  },
  {
    text: "Bill for first full month, Prorate second month billed later",
    value: "full_later",
  },
  {
    text: "Prorate this month and bill full billing cycle starting next month",
    value: "first_later",
  },
  {
    text: "Prorate this month and bill now for the first billing cycle",
    value: "first_now",
  },
]);
const showQuote = ref(false);
const units = ref();

const formErrors = ref<Record<string, string[]>>({});
const formFields = ref({
  move_in_on: moment().format("YYYY-MM-DD"),
  available_promotion_id: ref(),
  unit_type_id: "",
  additional_deposit: "",
  amount_rented_for: ref(""),
  available_tenant_protection_plan_id: "",
  billing_cycle: ref(1),
  charge_additional_deposit: "",
  charge_deposit: ref(true),
  charge_setup_fee: ref(true),
  deposit: "",
  discount_as_percentage: "",
  exempt_from_rate_management: ref(false),
  insurance_plan_id: "",
  mark_additional_deposit_as_paid: "",
  mark_deposit_as_paid: "",
  plan_id: "",
  prorated_amount: "",
  prorated_insurance_premium: "",
  prorating: "none",
  rented_on: moment().format("YYYY-MM-DD"),
  setup_fee: ref(),
  setup_fee_tax_rate_id: "",
  tax_rate_id: "",
  unit_id: "",
  rent_tax_rate_id: ref(),
});
const feesAndProducts = ref(Array<FeesProductInterface>());
const totalFeesProducts = ref(0);
const insurancePlans = ref();
const facility = ref();
onMounted(async () => {
  await getFacility();
  await getUnits();
  await getUnitTypes();
  await getPromotions();

  status.value = "completed";
  if (selectedUnitType.value) {
    if (
      facility.value.enabled_rental_coverage_signup_type ==
        "tenant_protection" &&
      selectedUnitType.value.allow_tenant_protection
    ) {
      await getProtectionPlans();
    } else if (
      facility.value.enabled_rental_coverage_signup_type == "insurance"
    ) {
      await getInsurances();
    }
  }
});
async function getFacility() {
  errors.value = "";
  const response = await api({
    url: `facility/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    facility.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getProtectionPlans() {
  errors.value = "";
  const response = await api({
    url: `available_tenant_protection_plans/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    tenantProtectionPlans.value = response.body;
    formFields.value.available_tenant_protection_plan_id =
      tenantProtectionPlans.value[0].id;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getInsurances() {
  errors.value = "";
  const response = await api({
    url: `insurances/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    insurancePlans.value = response.body;
    formFields.value.insurance_plan_id = insurancePlans.value[0].id;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
let daysInMonth = moment(formFields.value.move_in_on).daysInMonth();

watch(amountRented, () => {
  if (amountRented.value == "custom") {
    customPrice.value = true;
  } else if (amountRented.value.id) {
    formFields.value.amount_rented_for = amountRented.value.amount;
    formFields.value.plan_id = amountRented.value.id;
  } else {
    customPrice.value = false;
    formFields.value.amount_rented_for = amountRented.value;
    formFields.value.plan_id = "";
  }
});
watch(customAmount, () => {
  if (customAmount.value && amountRented.value == "custom") {
    formFields.value.amount_rented_for = customAmount.value;
  }
});
watch(formFields.value, () => {
  if (
    formFields.value.discount_as_percentage &&
    customAmount.value &&
    amountRented.value == "custom"
  ) {
    formFields.value.amount_rented_for = (
      Number(customAmount.value) -
      (Number(formFields.value.discount_as_percentage) / 100) *
        Number(customAmount.value)
    ).toString();
  }
  if (["first_now", "full_now"].includes(formFields.value.prorating)) {
    formFields.value.rented_on = moment(formFields.value.move_in_on)
      .add(2, "months")
      .set("date", 1)
      .format("YYYY-MM-DD")
      .toString();
  } else if (
    ["first_later", "full_later"].includes(formFields.value.prorating)
  ) {
    formFields.value.rented_on = moment(formFields.value.move_in_on)
      .add(1, "months")
      .set("date", 1)
      .format("YYYY-MM-DD")
      .toString();
  }
});
function updateFeesAndProducts(e: FeesProductInterface) {
  feesAndProducts.value.push(e);
  totalFeesProducts.value += Number(e.item_subtotal);
}
function proratedRent() {
  if (formFields.value.prorating != "none") {
    let currentDay = moment(formFields.value.move_in_on).format("DD");

    if (formFields.value.move_in_on) {
      let daysLeft = Number(daysInMonth) - Number(currentDay) + 1;
      let proratedAmount =
        Number(formFields.value.amount_rented_for) / daysInMonth;
      if (["full_now", "full_later"].includes(formFields.value.prorating)) {
        let daysInNextMonth = moment(formFields.value.move_in_on)
          .add(1, "months")
          .daysInMonth();
        daysLeft = Number(daysInNextMonth) - Number(currentDay) + 1;
        proratedAmount =
          Number(formFields.value.amount_rented_for) / daysInNextMonth;
      }
      return proratedAmount * daysLeft;
    }
    return "";
  }
  return null;
}
function proratedTenantFee() {
  if (formFields.value.prorating != "none") {
    let currentDay = moment(formFields.value.move_in_on).format("DD");

    let daysLeft = Number(daysInMonth) - Number(currentDay) + 1;
    let proratedAmount = Number(protectionPlan()) / daysInMonth;
    if (["full_now", "full_later"].includes(formFields.value.prorating)) {
      let daysInNextMonth = moment(formFields.value.move_in_on)
        .add(1, "months")
        .daysInMonth();
      daysLeft = Number(daysInNextMonth) - Number(currentDay) + 1;
      proratedAmount = Number(protectionPlan()) / daysInNextMonth;
    }
    if (formFields.value.prorating == "first_later") {
      if (formFields.value.available_tenant_protection_plan_id) {
        proratedAmount =
          Number(
            tenantProtectionPlans.value.filter(
              (item: TenantProtectionPlanInterface) =>
                item.id == formFields.value.available_tenant_protection_plan_id
            )[0].fee
          ) / daysInMonth;
      } else if (formFields.value.insurance_plan_id) {
        proratedAmount =
          Number(
            insurancePlans.value.filter(
              (item: { id: string }) =>
                item.id == formFields.value.insurance_plan_id
            )[0].premium
          ) / daysInMonth;
      }
    }
    return proratedAmount * daysLeft;
  }
  return null;
}
function removeFee(obj: FeesProductInterface) {
  feesAndProducts.value.splice(
    feesAndProducts.value.indexOf(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      feesAndProducts.value.find((item) => item == obj)
    ),
    1
  );
  if (totalFeesProducts.value) {
    totalFeesProducts.value -= Number(obj.item_subtotal);
  }
}
function rentTax() {
  if (selectedTaxRate.value) {
    let total = Number(rent());
    let prorated = proratedRent();
    if (prorated && formFields.value.prorating != "full_later") {
      total += Number(prorated);
    }
    if (rentPromotion()) {
      total -= rentPromotion();
    }

    return (Number(selectedTaxRate.value.value_as_percentage) / 100) * total;
  }
  return "";
}
function rent() {
  if (formFields.value.prorating == "first_later") {
    return 0.0;
  }
  return formFields.value.amount_rented_for;
}
function rentPromotion() {
  let promotion = promotions.value.filter(
    (item: { id: string }) => item.id == formFields.value.available_promotion_id
  )[0];
  let rentAmount = rent();
  if (promotion) {
    return (Number(promotion.percentage) / 100) * Number(rentAmount);
  } else {
    return 0;
  }
}
function rentTaxWithOutProrate() {
  if (selectedTaxRate.value) {
    let total = Number(formFields.value.amount_rented_for);

    return (Number(selectedTaxRate.value.value_as_percentage) / 100) * total;
  }
  return "";
}
function totalDue() {
  let total = 0;
  if (formFields.value.prorating != "first_later") {
    if (
      formFields.value.available_tenant_protection_plan_id ||
      formFields.value.insurance_plan_id
    ) {
      total += Number(protectionPlan());
    }
    if (formFields.value.available_promotion_id) {
      total += Number(rent()) - rentPromotion();
    } else {
      total += Number(rent());
    }
  }
  total += Number(rentTax()) + Number(protectionPlanTax());
  if (formFields.value.charge_deposit) {
    total += Number(formFields.value.deposit);
  }
  if (formFields.value.charge_setup_fee) {
    total += Number(formFields.value.setup_fee) + Number(setupFeeTax());
  }
  if (totalFeesProducts.value) {
    total += Number(totalFeesProducts.value);
  }
  if (formFields.value.prorating != "full_later") {
    let prorated_rent = proratedRent();
    let prorated_fee = proratedTenantFee();
    if (prorated_fee) {
      total += Number(prorated_fee);
    }
    if (prorated_rent) {
      total += Number(prorated_rent);
    }
  }

  total = Math.round(total * 100) / 100;
  return total;
}
function protectionPlan() {
  if (formFields.value.prorating == "first_later") {
    return 0.0;
  }
  if (formFields.value.available_tenant_protection_plan_id) {
    return Number(
      tenantProtectionPlans.value.filter(
        (item: TenantProtectionPlanInterface) =>
          item.id == formFields.value.available_tenant_protection_plan_id
      )[0].fee
    );
  } else if (formFields.value.insurance_plan_id) {
    return Number(
      insurancePlans.value.filter(
        (item: TenantProtectionPlanInterface) =>
          item.id == formFields.value.insurance_plan_id
      )[0].premium
    );
  }
  return 0.0;
}
async function getUnits() {
  errors.value = "";
  let url = `units/?status=available&facilityId=${props.facilityId}`;

  const response = await api({
    url,
  });
  if (response.status == 200) {
    units.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getPlans(unit_type_id: number) {
  errors.value = "";
  let url = `plans/?facilityId=${props.facilityId}&unit_type_id=${unit_type_id}`;

  const response = await api({
    url,
  });
  if (response.status == 200) {
    return response.body;
  } else {
    return null;
  }
}
function protectionPlanTax() {
  if (selectedTaxRate.value) {
    let total = protectionPlan();

    if (proratedTenantFee() && formFields.value.prorating != "full_later") {
      total += Number(proratedTenantFee());
    }
    return (Number(selectedTaxRate.value.value_as_percentage) / 100) * total;
  } else {
    return 0.0;
  }
}
function protectionPlanTaxWithout() {
  if (
    formFields.value.available_tenant_protection_plan_id &&
    selectedTaxRate.value
  ) {
    let total = tenantProtectionPlans.value.filter(
      (item: TenantProtectionPlanInterface) =>
        item.id == formFields.value.available_tenant_protection_plan_id
    )[0].fee;
    return (
      (Number(selectedTaxRate.value.value_as_percentage) / 100) * Number(total)
    );
  } else if (formFields.value.insurance_plan_id && selectedTaxRate.value) {
    let total = insurancePlans.value.filter(
      (item: TenantProtectionPlanInterface) =>
        item.id == formFields.value.insurance_plan_id
    )[0].premium;
    return (
      (Number(selectedTaxRate.value.value_as_percentage) / 100) * Number(total)
    );
  } else {
    return 0.0;
  }
}
function upcomingDue() {
  let total =
    Number(formFields.value.amount_rented_for) +
    Number(rentTaxWithOutProrate());
  if (formFields.value.available_tenant_protection_plan_id) {
    total +=
      protectionPlanTaxWithout() +
      Number(
        tenantProtectionPlans.value.filter(
          (item: TenantProtectionPlanInterface) =>
            item.id == formFields.value.available_tenant_protection_plan_id
        )[0].fee
      );
  }
  if (formFields.value.insurance_plan_id) {
    total +=
      protectionPlanTaxWithout() +
      Number(
        insurancePlans.value.filter(
          (item: TenantProtectionPlanInterface) =>
            item.id == formFields.value.insurance_plan_id
        )[0].premium
      );
  }

  return total;
}

function setupFeeTax() {
  if (selectedFeeTaxRate.value) {
    return (
      (selectedFeeTaxRate.value.value_as_percentage / 100) *
      Number(formFields.value.setup_fee)
    );
  }
  return "";
}

async function getPromotions() {
  errors.value = "";
  let url = `available_promotions/?facilityId=${props.facilityId}`;

  const response = await api({
    url,
  });
  if (response.status == 200) {
    promotions.value = response.body.available_promotions;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

function updateForm() {
  if (selectedUnitType.value) {
    formFields.value.unit_type_id = selectedUnitType.value.id;
    formFields.value.amount_rented_for = selectedUnitType.value.price;
    amountRented.value = selectedUnitType.value.price;
    formFields.value.deposit = selectedUnitType.value.deposit;
    selectedTaxRate.value = taxRates.value.filter(
      (item: TaxRateInterface) =>
        item.id == selectedUnitType.value.rent_tax_rate_id
    )[0];
    selectedFeeTaxRate.value = taxRates.value.filter(
      (item: TaxRateInterface) =>
        item.id == selectedUnitType.value.setup_fee_tax_rate_id
    )[0];
    formFields.value.tax_rate_id = selectedUnitType.value.rent_tax_rate_id;
    formFields.value.setup_fee_tax_rate_id =
      selectedUnitType.value.setup_fee_tax_rate_id;
    if (!formFields.value.setup_fee_tax_rate_id) {
      selectedFeeTaxRate.value = null;
    }
    if (!formFields.value.tax_rate_id) {
      selectedTaxRate.value = null;
    }
    if (selectedTaxRate.value) {
      formFields.value.tax_rate_id = selectedTaxRate.value.id;
    }
    formFields.value.setup_fee = selectedUnitType.value.setup_fee;
    if (selectedUnit.value) {
      formFields.value.unit_id = selectedUnit.value.id;
    }
  }
}
async function getTaxRates() {
  errors.value = "";
  const response = await api({
    url: `tax_rates/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    taxRates.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getUnitTypes() {
  errors.value = "";
  const response = await api({
    url: `unit_types/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    let unit_types = response.body;
    let types = [];
    for (let unit_type of unit_types) {
      unit_type.plans = await getPlans(unit_type.id);
      if (
        units.value.filter(
          (item: { unit_type_id: string }) => item.unit_type_id == unit_type.id
        )[0]
      ) {
        types.push(unit_type);
      }
    }
    unitTypes.value = types;

    await getTaxRates();
    selectedUnitType.value = unitTypes.value[0];
    updateForm();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function submitForm() {
  const json = JSON.parse(JSON.stringify(formFields.value));
  if (formFields.value.plan_id) {
    delete json.amount_rented_for;
  }
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `quote/?facilityId=${props.facilityId}`;
  const responseData = await api({
    url,
    method: "POST",
    json,
  });
  formSubmitting.value = false;
  if (responseData.status === 200) {
    quote.value = responseData.body;
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
  showQuote.value = true;
}
function print() {
  window.print();
}

return (_ctx: any,_cache: any) => {
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!showQuote.value)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "New Quote"))
      : (selectedUnitType.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h1", null, " Quote for " + _toDisplayString(selectedUnitType.value.length) + " x " + _toDisplayString(selectedUnitType.value.width), 1),
            _createElementVNode("div", null, [
              _createElementVNode("p", null, _toDisplayString(facility.value.name), 1),
              _createElementVNode("p", null, _toDisplayString(facility.value.address), 1),
              _createElementVNode("p", null, _toDisplayString(facility.value.city) + ", " + _toDisplayString(facility.value.state) + " " + _toDisplayString(facility.value.physical_zip), 1)
            ])
          ]))
        : _createCommentVNode("", true),
    _createElementVNode("form", {
      class: "large-width-centered",
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      (unitTypes.value)
        ? (_openBlock(), _createElementBlock("fieldset", _hoisted_4, [
            (status.value === 'loading')
              ? (_openBlock(), _createBlock(BaseSpinner, {
                  key: 0,
                  preset: "large"
                }))
              : _createCommentVNode("", true),
            (status.value == 'completed')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (!showQuote.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedUnitType).value = $event)),
                            required: "",
                            class: "form-select",
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (updateForm()))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitTypes.value, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item + 'id',
                                value: item
                              }, [
                                (item.length === 0 && item.width === 0 && item.name)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(item.length) + " x " + _toDisplayString(item.width), 1)
                                    ], 64))
                              ], 8, _hoisted_9))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, selectedUnitType.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.rented_on) = $event)),
                            type: "date",
                            required: "",
                            disabled: 
                ['first_now', 'first_later', 'full_now', 'full_later'].includes(
                  formFields.value.prorating
                )
              
                          }, null, 8, _hoisted_12), [
                            [_vModelText, formFields.value.rented_on]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          (promotions.value && promotions.value.length && selectedUnitType.value)
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 0,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFields.value.available_promotion_id) = $event)),
                                class: "form-select"
                              }, [
                                _hoisted_15,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promotions.value, (promotion) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: promotion.id + 'promotion'
                                  }, [
                                    (
                  !promotion.expired &&
                  promotion.unit_types.find(
                    (item) => item.id == selectedUnitType.value.id
                  )
                )
                                      ? (_openBlock(), _createElementBlock("option", {
                                          key: 0,
                                          value: promotion.id
                                        }, _toDisplayString(promotion.name) + " - " + _toDisplayString(promotion.description), 9, _hoisted_16))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ], 512)), [
                                [_vModelSelect, formFields.value.available_promotion_id]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        (selectedUnitType.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _hoisted_18,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((amountRented).value = $event)),
                                class: "form-select",
                                required: ""
                              }, [
                                _createElementVNode("option", {
                                  value: selectedUnitType.value.price
                                }, " $ " + _toDisplayString(selectedUnitType.value.price) + " per month ", 9, _hoisted_19),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedUnitType.value.plans, (plan) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: plan.id + 'plan',
                                    value: plan
                                  }, [
                                    _createTextVNode(" Override Price Plan - $ " + _toDisplayString(plan.amount) + " per " + _toDisplayString(plan.months) + " ", 1),
                                    (plan.months > 1)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _hoisted_21
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _hoisted_22
                                        ], 64))
                                  ], 8, _hoisted_20))
                                }), 128)),
                                _hoisted_23
                              ], 512), [
                                [_vModelSelect, amountRented.value]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (customPrice.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _hoisted_26,
                                _hoisted_27,
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((customAmount).value = $event)),
                                  type: "number",
                                  step: ".01",
                                  required: ""
                                }, null, 512), [
                                  [_vModelText, customAmount.value]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _hoisted_30,
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formFields.value.discount_as_percentage) = $event)),
                                  type: "number",
                                  step: ".01",
                                  required: ""
                                }, null, 512), [
                                  [_vModelText, formFields.value.discount_as_percentage]
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_31,
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formFields.value.billing_cycle) = $event)),
                                  class: "form-select",
                                  required: ""
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(billingOptions.value, (cycle) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: cycle + 'cycle',
                                      value: cycle
                                    }, [
                                      (cycle != 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(cycle) + " months", 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_34, "28 days"))
                                    ], 8, _hoisted_32))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, formFields.value.billing_cycle]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (tenantProtectionPlans.value && tenantProtectionPlans.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              _hoisted_36,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formFields.value.available_tenant_protection_plan_id) = $event)),
                                class: "form-select"
                              }, [
                                _hoisted_37,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenantProtectionPlans.value, (plan) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: plan.id + 'plan',
                                    value: plan.id
                                  }, " $" + _toDisplayString(plan.limit) + " protection for $" + _toDisplayString(plan.fee) + " per month ", 9, _hoisted_38))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, formFields.value.available_tenant_protection_plan_id]
                              ]),
                              _hoisted_39
                            ]))
                          : _createCommentVNode("", true),
                        (insurancePlans.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _hoisted_41,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formFields.value.insurance_plan_id) = $event)),
                                class: "form-select"
                              }, [
                                _hoisted_42,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(insurancePlans.value, (plan) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: plan.id + 'plan',
                                    value: plan.id
                                  }, _toDisplayString(plan.summary), 9, _hoisted_43))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, formFields.value.insurance_plan_id]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_44, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formFields.value.charge_deposit) = $event)),
                            type: "checkbox",
                            class: "form-check-input"
                          }, null, 512), [
                            [_vModelCheckbox, formFields.value.charge_deposit]
                          ]),
                          _hoisted_45
                        ]),
                        (formFields.value.charge_deposit)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _hoisted_48,
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formFields.value.deposit) = $event)),
                                  type: "number",
                                  step: ".01",
                                  required: ""
                                }, null, 512), [
                                  [_vModelText, formFields.value.deposit]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_49, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formFields.value.mark_deposit_as_paid) = $event)),
                                  type: "checkbox",
                                  class: "form-check-input"
                                }, null, 512), [
                                  [_vModelCheckbox, formFields.value.mark_deposit_as_paid]
                                ]),
                                _hoisted_50
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_51, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formFields.value.charge_setup_fee) = $event)),
                            type: "checkbox",
                            class: "form-check-input"
                          }, null, 512), [
                            [_vModelCheckbox, formFields.value.charge_setup_fee]
                          ]),
                          _hoisted_52
                        ]),
                        (formFields.value.charge_setup_fee)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _hoisted_55,
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formFields.value.setup_fee) = $event)),
                                  type: "number",
                                  step: ".01",
                                  required: ""
                                }, null, 512), [
                                  [_vModelText, formFields.value.setup_fee]
                                ])
                              ]),
                              (taxRates.value && taxRates.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                    _hoisted_57,
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedFeeTaxRate).value = $event)),
                                      class: "form-select",
                                      required: ""
                                    }, [
                                      _hoisted_58,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxRates.value, (tax) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: tax.id + 'tax',
                                          value: tax
                                        }, _toDisplayString(tax.value_as_percentage), 9, _hoisted_59))
                                      }), 128))
                                    ], 512), [
                                      [_vModelSelect, selectedFeeTaxRate.value]
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(FeeProduct, {
                          "facility-id": __props.facilityId,
                          onFeesAndProducts: updateFeesAndProducts
                        }, null, 8, ["facility-id"]),
                        _createElementVNode("div", _hoisted_60, [
                          _hoisted_61,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formFields.value.prorating) = $event)),
                            class: "form-select"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proratingOptions.value, (rate) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: rate.value + 'rate',
                                value: rate.value
                              }, _toDisplayString(rate.text), 9, _hoisted_62))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, formFields.value.prorating]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formFields.value.move_in_on) = $event)),
                            type: "date",
                            required: ""
                          }, null, 512), [
                            [_vModelText, formFields.value.move_in_on]
                          ])
                        ]),
                        (taxRates.value && taxRates.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                              _hoisted_66,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((selectedTaxRate).value = $event)),
                                class: "form-select",
                                required: ""
                              }, [
                                _hoisted_67,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxRates.value, (tax) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: tax.id + 'tax',
                                    value: tax
                                  }, _toDisplayString(tax.value_as_percentage), 9, _hoisted_68))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, selectedTaxRate.value]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("table", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_69,
                      _createElementVNode("td", null, "$" + _toDisplayString(rent()), 1)
                    ]),
                    (formFields.value.available_promotion_id)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_70, [
                          _hoisted_71,
                          _createElementVNode("td", null, "$" + _toDisplayString(rentPromotion().toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (proratedRent() && formFields.value.prorating != 'full_later')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_72, [
                          _hoisted_73,
                          _createElementVNode("td", null, "$" + _toDisplayString(Number(proratedRent()).toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (formFields.value.prorated_amount)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_74, [
                          _hoisted_75,
                          _createElementVNode("td", null, "$" + _toDisplayString(formFields.value.prorated_amount), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _hoisted_76,
                      (selectedTaxRate.value && rentTax())
                        ? (_openBlock(), _createElementBlock("td", _hoisted_77, " $" + _toDisplayString(Number(rentTax()).toFixed(2)) + " (" + _toDisplayString(selectedTaxRate.value.value_as_percentage) + "%) ", 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_78))
                    ]),
                    (
              tenantProtectionPlans.value &&
              (formFields.value.available_tenant_protection_plan_id ||
                formFields.value.insurance_plan_id)
            )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          (tenantProtectionPlans.value)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_79, [
                                _createElementVNode("td", null, [
                                  (formFields.value.available_tenant_protection_plan_id)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_80
                                      ], 64))
                                    : (formFields.value.insurance_plan_id)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _hoisted_81
                                        ], 64))
                                      : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, "$" + _toDisplayString(protectionPlan().toFixed(2)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (proratedTenantFee() && formFields.value.prorating != 'full_later')
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_82, [
                                _createElementVNode("td", null, [
                                  (formFields.value.available_tenant_protection_plan_id)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_83
                                      ], 64))
                                    : (formFields.value.insurance_plan_id)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _hoisted_84
                                        ], 64))
                                      : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, "$" + _toDisplayString(proratedTenantFee()?.toFixed(2)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (tenantProtectionPlans.value)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_85, [
                                _createElementVNode("td", null, [
                                  (formFields.value.available_tenant_protection_plan_id)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_86
                                      ], 64))
                                    : (formFields.value.insurance_plan_id)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _hoisted_87
                                        ], 64))
                                      : _createCommentVNode("", true)
                                ]),
                                (selectedTaxRate.value && protectionPlanTax())
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_88, " $" + _toDisplayString(protectionPlanTax().toFixed(2)) + " (" + _toDisplayString(selectedTaxRate.value.value_as_percentage) + "%) ", 1))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_89))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (formFields.value.charge_deposit)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_90, [
                          _hoisted_91,
                          _createElementVNode("td", null, "$" + _toDisplayString(formFields.value.deposit), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (formFields.value.charge_setup_fee)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_92, [
                          _hoisted_93,
                          (formFields.value.setup_fee)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_94, "$" + _toDisplayString(formFields.value.setup_fee), 1))
                            : (_openBlock(), _createElementBlock("td", _hoisted_95))
                        ]))
                      : _createCommentVNode("", true),
                    (formFields.value.charge_setup_fee)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_96, [
                          _hoisted_97,
                          (selectedFeeTaxRate.value)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_98, " $" + _toDisplayString(Number(setupFeeTax()).toFixed(2)) + " (" + _toDisplayString(selectedFeeTaxRate.value.value_as_percentage) + "%) ", 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (feesAndProducts.value.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 7 }, _renderList(feesAndProducts.value, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.id + 'item'
                          }, [
                            _createElementVNode("td", null, _toDisplayString(item.action_name) + " due on " + _toDisplayString(item.due_on), 1),
                            _createElementVNode("td", null, [
                              _createTextVNode(" $" + _toDisplayString(Number(item.item_subtotal).toFixed(2)) + " ", 1),
                              _createElementVNode("a", {
                                onClick: ($event: any) => (removeFee(item))
                              }, "remove", 8, _hoisted_99)
                            ])
                          ]))
                        }), 128))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _hoisted_100,
                      _createElementVNode("td", null, "$" + _toDisplayString(totalDue().toFixed(2)), 1)
                    ]),
                    (proratedTenantFee() && formFields.value.prorating == 'full_later')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_101, [
                          _createElementVNode("td", null, [
                            (formFields.value.available_tenant_protection_plan_id)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" Prorated Tenant Protection Fee due on " + _toDisplayString(formFields.value.rented_on), 1)
                                ], 64))
                              : (formFields.value.insurance_plan_id)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" Prorated Insurance Fee due on " + _toDisplayString(formFields.value.rented_on), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, "$" + _toDisplayString(proratedTenantFee()?.toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (proratedRent() && formFields.value.prorating == 'full_later')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_102, [
                          _createElementVNode("td", null, "Prorated second month due on " + _toDisplayString(formFields.value.rented_on), 1),
                          _createElementVNode("td", null, "$" + _toDisplayString(Number(proratedRent()).toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, " Amount due every month starting on " + _toDisplayString(formFields.value.rented_on), 1),
                      _createElementVNode("td", null, [
                        _createTextVNode(" $" + _toDisplayString(upcomingDue().toFixed(2)), 1),
                        (taxRates.value && taxRates.value.length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_103, " (tax included)"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_104, [
        _createElementVNode("button", {
          disabled: formSubmitting.value,
          type: "submit",
          class: "btn btn-text"
        }, [
          (formSubmitting.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                _hoisted_107,
                _createVNode(BaseSpinner)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_108, "Generate Quote"))
        ], 8, _hoisted_105)
      ]),
      (formErrors.value.non_field_errors !== undefined)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 1,
            variant: "danger",
            class: "js-form-error",
            dismissible: "",
            onDismissed: _cache[19] || (_cache[19] = ($event: any) => (formErrors.value = {}))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(formErrors.value.non_field_errors[0]), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 40, _hoisted_3),
    (showQuote.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
          _hoisted_110,
          _createElementVNode("div", _hoisted_111, [
            _createElementVNode("fieldset", null, [
              _hoisted_112,
              _createElementVNode("button", {
                class: "btn",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (print()))
              }, "PDF")
            ]),
            _createElementVNode("fieldset", null, [
              _hoisted_113,
              _createVNode(_component_RouterLink, {
                to: {
            name: 'customer',
            params: { rental: 'true', facilityId: __props.facilityId },
          },
                class: "btn"
              }, {
                default: _withCtx(() => [
                  _hoisted_114
                ]),
                _: 1
              }, 8, ["to"]),
              _hoisted_115,
              _hoisted_116
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})